<template lang="pug">
  div
    .d-flex.flex-row.align-items-center
      font-awesome-icon.account-page__icon(:icon="['far', 'list-alt']")
      h3.account-page__title {{ trans('menus.frontend.navigation.orders') }}
    .table-responsive(data-slideout-ignore)
      table.table.table--orders
        thead
          tr
            th {{ trans('menus.frontend.navigation.orders') }}
            th.d-none.d-xl-table-cell {{ trans('labels.frontend.account.orders.table.date') }}
            th.d-none.d-xl-table-cell {{ trans('labels.frontend.account.orders.table.status') }}
            th.d-none.d-xl-table-cell {{ trans('labels.frontend.account.orders.table.tracking') }}
            th.d-none.d-xl-table-cell {{ trans('labels.frontend.account.orders.table.net_total') }}
            th.d-none.d-xl-table-cell
        tbody
          tr(v-if="orders.length === 0")
            td.text-center(colspan="6") {{ trans('labels.frontend.account.orders.table.no_order') }}
          tr(v-for="order in orders" :key="order.id")
            td
              router-link(:to="{ name: 'account.orders.show', params: { number: order.number } }" :title="order.number") {{ '#' + order.number }}
              div.table__responsive-box.d-block.d-xl-none
                p {{ order.created_at | moment('D MMMM Y') }}
                strong.order-item__due-date.d-block.mb-2(v-if="order.due_date && order.status === 'pending_order'")
                  | {{ trans('labels.frontend.account.orders.will_expire') }} {{ order.due_date | moment('D/M/Y') }} {{ trans('labels.general.time') }} {{ order.due_date | moment('HH:mm') }}
                span(v-if="order.tracking_number") เลขติดตามพัสดุ {{ order.tracking_number }}
                .row.align-items-center.mb-2
                  .col-6
                    span.badge.badge-lg(v-bind:class="statusClass(order.status)")
                      | {{ order.status_label }}
                  .col-6.text-right
                    span ฿ {{ order.net_total | numeral }} {{ trans('labels.general.baht') }}
            td.d-none.d-xl-table-cell
              | {{ order.created_at | moment('D MMMM Y') }}
              strong.order-item__due-date.d-block(v-if="order.due_date && order.status === 'pending_order'")
                | {{ trans('labels.frontend.account.orders.will_expire') }} {{ order.due_date | moment('D/M/Y') }} {{ trans('labels.general.time') }} {{ order.due_date | moment('HH:mm') }}
            td.d-none.d-xl-table-cell
              span.badge.badge-lg(v-bind:class="statusClass(order.status)")
                | {{ order.status_label }}
            td.d-none.d-xl-table-cell(v-if="order.tracking_number") {{ order.tracking_number }}
            td.d-none.d-xl-table-cell(v-if="!order.tracking_number") -
            td.d-none.d-xl-table-cell ฿ {{ order.net_total | numeral }}
            td.d-none.d-xl-table-cell
              router-link.btn.btn-primary.btn-outline.btn-sm.btn-text-black(
                :to="{ name: 'account.orders.show', params: { number: order.number } }"
                :title="order.number"
              ) {{ trans('labels.frontend.account.orders.table.manage') }}
              router-link.btn.btn-primary.btn-sm.ml-2(:to="{ name: 'account.payment-notify' }", v-if="order.status === 'pending_order'", :title="trans('menus.frontend.navigation.payment-notify')")
                | {{ trans('menus.frontend.navigation.payment-notify') }}
    .row(v-if="options.pagination && options.pagination.last_page > 1")
      .col-12
        b-pagination(
          v-if="options.pagination"
          v-model="options.pagination.current_page"
          :total-rows="options.pagination.total"
          :per-page="options.pagination.per_page"
          @change="onPageChange"
        )
</template>

<script>
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import { RepositoryFactory } from '../../../repositoryFactory';

const OrderRepository = RepositoryFactory.get('order');

export default {
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('menus.frontend.navigation.orders'),
    };
  },
  data() {
    return {
      orders: [],
      options: {},
      filters: {},
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('menus.frontend.navigation.orders') },
    ]);
  },
  mounted() {
    this.getOrders();
    this.$watch('filters', _.debounce(() => {
      this.getOrders();
    }, 300), { deep: true });
  },
  methods: {
    async getOrders() {
      const response = await OrderRepository.get({ sort: 'created_at|desc', ...this.filters }).then((resp) => resp.data);
      this.orders = response.data;
      this.options = {
        ...this.options,
        ...{
          pagination: response.meta,
        },
      };
    },
    onPageChange(page) {
      this.filters = { ...this.filters, ...{ page } };
    },
    statusClass(status) {
      return {
        'badge-warning': status === 'pending_payment' || status === 'pending_shipping' || status === 'pending_order',
        'badge-success': status === 'shipped',
        'badge-danger': status === 'canceled',
      };
    },
  },
};
</script>
